(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	function isSafari() {
			const userAgent = navigator.userAgent;
			return /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
	}

	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.elements.panel.addEventListener(
				'mouseleave',
				this.openSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			if (isSafari() && this.elements.button.getAttribute('is-button-clicked') === 'true') {
				return;
			}

			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();

				if (isSafari()) {
					this.elements.button.setAttribute('is-button-clicked', 'true');

					setTimeout(() => {
						this.elements.button.setAttribute('is-button-clicked', 'false');
					}, 150);
				}
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
	class StickyHeader extends HTMLElement {
		constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerOverlay = document.querySelector('.header-overlay');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;

		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-sticky','always-fixed');
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
				this.headerOverlay.classList.remove('color-inverse');
			}
		};

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
			observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
			requestAnimationFrame(this.reveal.bind(this));
			}else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (document.querySelector(".search-modal.active")) return;
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		if (this.headerOverlay) {
			this.headerOverlay.classList.add('color-background-1');
		}
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden','color-inverse');
		if (this.headerOverlay) {
			this.headerOverlay.classList.add('color-background-1');
			this.headerOverlay.classList.remove('color-inverse');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.headerOverlay) {
			this.headerOverlay.classList.remove('color-background-1');
			this.headerOverlay.classList.add('color-inverse');
		}
	}

	//closeMenuDisclosure() {
	//	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	//	this.disclosures.forEach(disclosure => disclosure.close());
	//}

	}

	customElements.define('sticky-header', StickyHeader);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joffz-countdown-announcement-v56"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initBar(root){
    if(!root || root.dataset.jzcaReady === 'true') return;
    root.dataset.jzcaReady = 'true';

    var hoursEl = root.querySelector('[data-jzca-hours]');
    var minutesEl = root.querySelector('[data-jzca-minutes]');
    var secondsEl = root.querySelector('[data-jzca-seconds]');
    var end = Date.parse(root.dataset.endDate || '');
    if(!Number.isFinite(end) || !hoursEl || !minutesEl || !secondsEl){ root.hidden = true; return; }

    function updateTimer(){
      var remaining = end - Date.now();
      if(remaining <= 0){ root.hidden = true; return false; }
      var totalSeconds = Math.floor(remaining / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      hoursEl.textContent = String(hours);
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
      root.hidden = false;
      return true;
    }

    if(!updateTimer()) return;
    var timerInterval = window.setInterval(function(){ if(!updateTimer()) window.clearInterval(timerInterval); }, 1000);

    var messages = Array.prototype.slice.call(root.querySelectorAll('[data-jzca-message]'));
    var index = 0;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var rotationMs = parseInt(root.dataset.rotationMs || '4000', 10);
    if(messages.length > 1 && !reduceMotion){
      window.setInterval(function(){
        if(root.hidden) return;
        messages[index].classList.remove('is-active');
        index = (index + 1) % messages.length;
        messages[index].classList.add('is-active');
      }, Math.max(rotationMs, 2000));
    }
  }

  function initAll(scope){
    var rootScope = scope || document;
    var bars = rootScope.matches && rootScope.matches('[data-jzca-v56]') ? [rootScope] : rootScope.querySelectorAll('[data-jzca-v56]');
    Array.prototype.forEach.call(bars, initBar);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initAll(document); }); else initAll(document);
  document.addEventListener('shopify:section:load', function(event){ initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joffz-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('joffz-product-recommendations')) {
    class JoffzProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.observed === 'true') return;
        this.dataset.observed = 'true';

        const observer = new IntersectionObserver((entries, instance) => {
          if (!entries[0].isIntersecting) return;
          instance.unobserve(this);
          this.loadRecommendations();
        }, { rootMargin: '0px 0px 350px 0px' });

        observer.observe(this);
      }

      async loadRecommendations() {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';

        try {
          const response = await fetch(this.dataset.url, { credentials: 'same-origin' });
          if (!response.ok) return;
          const text = await response.text();
          const wrapper = document.createElement('div');
          wrapper.innerHTML = text;
          const recommendations = wrapper.querySelector('joffz-product-recommendations');
          if (!recommendations || !recommendations.innerHTML.trim()) return;
          this.innerHTML = recommendations.innerHTML;
          this.initSlider();
        } catch (error) {
          console.error(error);
        }
      }

      initSlider() {
        const slider = this.querySelector('[data-jz-rec-slider]');
        if (!slider || slider.swiper || typeof window.Swiper === 'undefined') return;

        const autoplayEnabled = this.dataset.autoplay === 'true';
        const stopOnHover = this.dataset.stopAutoplay === 'true';
        const delay = Math.max(500, Number(this.dataset.delay || 3) * 1000);
        const speed = Math.max(150, Number(this.dataset.speed || .5) * 1000);

        const options = {
          speed,
          spaceBetween: 16,
          slidesPerView: 2,
          navigation: {
            nextEl: this.querySelector('.jz-rec-next'),
            prevEl: this.querySelector('.jz-rec-prev')
          },
          breakpoints: {
            750: { slidesPerView: 3 },
            1100: { slidesPerView: 4 }
          }
        };

        if (autoplayEnabled) {
          options.autoplay = { delay, pauseOnMouseEnter: stopOnHover, disableOnInteraction: false };
        }

        new window.Swiper(slider, options);
      }
    }

    customElements.define('joffz-product-recommendations', JoffzProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer-backup-minimal-20260811"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'input',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer-pre-v47-20260905"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'input',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		if (activeMedia) {
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
		}
		
		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-featured-collection-11-37ba58"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSlider = (slider) => {
      if (!slider || slider.dataset.jzReady === 'true') return;
      if (typeof window.Swiper === 'undefined') {
        window.setTimeout(() => initSlider(slider), 60);
        return;
      }

      const root = slider.closest('.jz-fc11');
      if (!root) return;

      slider.dataset.jzReady = 'true';
      new window.Swiper(slider, {
        speed: 300,
        navigation: {
          nextEl: root.querySelector('.jz-fc11__next'),
          prevEl: root.querySelector('.jz-fc11__prev')
        },
        breakpoints: {
          320: {
            spaceBetween: Number(slider.dataset.gapMobile || 0),
            slidesPerView: Number(slider.dataset.viewMobile || 1.5)
          },
          768: {
            spaceBetween: Number(slider.dataset.gapMobile || 0),
            slidesPerView: Math.max(1, Math.round(Number(slider.dataset.view || 4) * .5))
          },
          1024: {
            spaceBetween: Number(slider.dataset.gap || 0),
            slidesPerView: Number(slider.dataset.view || 4)
          }
        }
      });
    };

    const initAll = (root = document) => {
      if (root.matches && root.matches('[data-jz-fc11]')) initSlider(root);
      root.querySelectorAll?.('[data-jz-fc11]').forEach(initSlider);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-gallery-10-c63cd8"] && !Shopify.designMode) return;
  try {
    
(function () {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-joffz-gallery]').forEach((root) => {
      if (root.dataset.joffzGalleryReady === 'true') return;
      root.dataset.joffzGalleryReady = 'true';

      const cards = Array.from(root.querySelectorAll('[data-gallery-card]'));
      const modal = root.querySelector('[data-gallery-modal]');
      const image = root.querySelector('[data-gallery-modal-image]');
      const close = root.querySelector('[data-gallery-close]');
      const prev = root.querySelector('[data-gallery-prev]');
      const next = root.querySelector('[data-gallery-next]');
      if (!cards.length || !modal || !image) return;

      let active = 0;
      let oldOverflow = '';

      const render = (index) => {
        active = Math.max(0, Math.min(index, cards.length - 1));
        const card = cards[active];
        const small = card.dataset.small || '';
        const medium = card.dataset.medium || small;
        const full = card.dataset.full || medium;
        image.alt = card.dataset.alt || '';
        image.src = full;
        image.srcset = `${small} 720w, ${medium} 1100w, ${full} 1600w`;
        image.sizes = '(max-width: 749px) 96vw, 80vw';
        if (prev) prev.disabled = active === 0;
        if (next) next.disabled = active === cards.length - 1;
      };

      const open = (index) => {
        oldOverflow = document.body.style.overflow;
        render(index);
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        close?.focus();
      };

      const shut = () => {
        modal.hidden = true;
        document.body.style.overflow = oldOverflow;
        image.removeAttribute('src');
        image.removeAttribute('srcset');
        cards[active]?.focus();
      };

      cards.forEach((card, index) => card.addEventListener('click', () => open(index)));
      close?.addEventListener('click', shut);
      prev?.addEventListener('click', () => render(active - 1));
      next?.addEventListener('click', () => render(active + 1));
      modal.addEventListener('click', (event) => { if (event.target === modal) shut(); });
      document.addEventListener('keydown', (event) => {
        if (modal.hidden) return;
        if (event.key === 'Escape') shut();
        if (event.key === 'ArrowLeft' && active > 0) render(active - 1);
        if (event.key === 'ArrowRight' && active < cards.length - 1) render(active + 1);
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
